import React, { useState, useEffect } from 'react';
import { DriverGrid } from './DriversGrid';
import { DispatchMap } from './Map';
import { SelectDriversProvider } from './SelectDriversContext';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import { getGridSectionClass, getMapSectionClass } from './selectDriversLayoutUtils';

export { getGridSectionClass, getMapSectionClass } from './selectDriversLayoutUtils';

export interface SelectDriversProps {
  classes?: Record<string, string>;
  routes: Array<{ driverId: string; [key: string]: unknown }>;
  selectedDriverIds: string[];
  onSelectionChange: (driverIds: string[]) => void;
  selectedPickupsList?: unknown[];
  userData?: unknown;
  glEventHub?: unknown;
  configJSON?: unknown;
  featureFlags?: { isFeatureEnabled: (name: string) => boolean };
  DispatchStore?: unknown;
  CommonStore?: unknown;
}

const SelectDrivers: React.FC<SelectDriversProps> = (props) => {
  const { classes } = props;
  const [quickFilterText, setQuickFilterText] = useState('');
  const [maximizedPanel, setMaximizedPanel] = useState<MaximizedPanel>(null);

  useEffect(() => {
    const hub = props.glEventHub as { emit?: (event: string) => void } | undefined;
    hub?.emit?.('mapResize');
  }, [maximizedPanel, props.glEventHub]);

  const contextValue = {
    routes: props.routes,
    selectedDriverIds: props.selectedDriverIds,
    onSelectionChange: props.onSelectionChange,
    selectedPickupsList: props.selectedPickupsList,
    userData: props.userData,
    glEventHub: props.glEventHub,
    configJSON: props.configJSON,
    featureFlags: props.featureFlags,
    DispatchStore: props.DispatchStore,
    CommonStore: props.CommonStore,
    quickFilterText,
    setQuickFilterText,
    maximizedPanel,
    setMaximizedPanel,
  };

  return (
    <SelectDriversProvider value={contextValue}>
      <div className={classes?.container}>
        <div className={getGridSectionClass(classes, maximizedPanel)}>
          <DriverGrid />
        </div>
        <div className={getMapSectionClass(classes, maximizedPanel)}>
          <DispatchMap contentWrapperClassName={classes?.mapSectionWrapper} />
        </div>
      </div>
    </SelectDriversProvider>
  );
};

export default withStyles(styles)(SelectDrivers);
